import { render, staticRenderFns } from "./81.vue?vue&type=template&id=49a162bb&scoped=true&"
var script = {}
import style0 from "./81.vue?vue&type=style&index=0&id=49a162bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a162bb",
  null
  
)

export default component.exports